/* eslint-disable @typescript-eslint/no-explicit-any */
import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";

type Answer = {
    id: string;
    answer: string;
};

type Question = {
    id:string;
    question: string;
    choices: Answer[];
    explanation:string;
    attachment:string;
    figure:string[];
    correctAnswerId: string;
};

export type QuizDTO = {
    id: string;
    title: string;
    duration:number;
    chapter: string | null;
    lecture: string | null;
    questions: Question[];
};

type GetQuizResponse = {
    statusCode?: number;
    error?: ApiError | null;
    data?: QuizDTO;
};

export const GetExamMCQById = async (quizId: string): Promise<GetQuizResponse> => {
    try {
        const response = await axios.get(`/exam/part1/${quizId}`);
            return { data: response.data };
    } catch (error: any) {
        console.error("API Error:", error);
        if (error.response) {
            const apiError: ApiError = {
                statusCode: error.response.status,
                message: error.response.data.message,
                error: error.response.data.error,
            };
            return { error: apiError };
        } else {
            const fallbackError: ApiError = {
                statusCode: 500,
                message: "An unexpected error occurred",
            };
            return { error: fallbackError };
        }
    }
};